<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
  [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
  [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  
  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)"
    [click]="false"
  />

  <div contenido class="contenido">
    <div class="headers w3-titulo-contenidomenuSC">
      <div class="w3-half">
        <span class="w3-margin-left-contenido">{{ 'liquidez.gap.tituloTabla' | translate }}</span>
        <span class="w3-margin-left-filter w3-subtitulo">({{formato}})</span>
        <span class="w3-margin-left-contenido">&bull;</span>
        <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles)}}</span>
      </div>
      <div class="w3-rest w3-right">
        <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menutabla1">
          more_vert
        </mat-icon>
      </div>
      <div class="w3-row" style="width: 100%; height: 1vh;"></div>
    </div>
    <div class="zonaTabla w3-scroll w3-white">
      @if (dataOrdenado.length !== 0) {
        <table class="w3-table borderAllLow">
          <thead>
            <tr class="w3-table-title" style="line-height: 1.2;">
              <th class="stikyColumB alinLeft w3-elemento-titulo-table"></th>
              <th [attr.colspan]="(bandas.length ?? 0) + 3" class="stikyColum w3-elemento-titulo-table w3-center borderIzq borderInf">
                {{ 'liquidez.gap.tituloTabla4' | translate }}
              </th>
            </tr>
            <tr class="w3-table-title" style="line-height: 1.2;">
              <th class="stikyColumB2 alinLeft w3-elemento-titulo-table"></th>
              @for (ban of bandas; track $index) {
                <th class="stikyColum2 w3-center textoOverFlow w3-elemento-titulo-table w3-border-right-balance marginsH">
                  {{ (idPlantilla === 7 ? 'liquidez.gap.'+ban : ban) | translate}}
                </th>
              }
              <th colspan="3" class="stikyColum2 w3-center w3-elemento-titulo-table borderIzq">
                {{ 'liquidez.gap.tituloTabla2' | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            @for (tab of dataOrdenado; track tab.id; let t = $index) {
              @if (t === 0 || t === 5 || t > 7) {
                <tr>
                  <th>
                    <br>
                  </th>
                  <th [attr.colspan]="(bandas.length ?? 0) + 3">
                    <br>
                  </th>
                </tr>
                <tr>
                  <th class="stikyColum3 alinLeft w3-elemento-titulo-table borderIzq">
                    {{ 'liquidez.gap.titSec'+t | translate }}
                  </th>
                  <th [attr.colspan]="(bandas.length ?? 0) + 3" class="stikyColumB3 w3-elemento-titulo-table borderIzq"></th>
                </tr>
              }
              @for (elem of tab; track elem.codigo; let i = $index) {
                @if (elem.codigo === 'suma') {
                  <tr class="w3-table-trtd">
                    <td [ngClass]="{'total':elem.codigo==='suma'}" class="w3-elemento-tableIndicador borderInf borderIzq borderDer"
                      style="min-width: max-content !important; white-space: nowrap;">
                      @if (t >= 5) {
                        @if (mostrarIcon(t,i)) {
                          <div (click)="tablasExpand[t]=!tablasExpand[t]" class="w3-button" style="cursor: pointer;">
                            <mat-icon class="iconoMen">
                              {{tablasExpand[t]?'expand_less':'expand_more'}}
                            </mat-icon>{{elem.name}}
                          </div>                        
                        }@else {
                          {{elem.name}}
                        }
                      }@else {
                        @if (mostrarIcon(t,i)) {
                          <div (click)="tablasExpand[t]=!tablasExpand[t]" class="w3-button" style="cursor: pointer;">
                            <mat-icon class="iconoMen">
                              {{tablasExpand[t]?'expand_less':'expand_more'}}
                            </mat-icon>
                            Total {{ 'liquidez.gap.tabla'+(t+1) | translate }}
                          </div>                        
                        }
                      }
                    </td>
                    @for (ban of elem.bandas; track ban; let j = $index) {
                      @if (ban !== null) {
                        <td [ngClass]="{'total':elem.codigo==='suma','redText':ban<0}" class="w3-elemento-tableIndicador borderSup alinRight borderInf widthMin borderIzq borderDer">
                          @if (elem.codigo!=='texto') {
                            <span style="margin-right: 5%;">
                              {{formNum(ban, false)}}
                            </span>
                          }@else {
                            <div [ngClass]="{'redTexts':ban==='VRL','yellowTexts':ban==='Cubierto con AL','greenTexts':ban==='GAP positivo'}" style="font-weight: 500;">
                              {{ban}}
                            </div>
                          }
                          @if (elem.codigo==='porcentaje') {
                            <span style="margin-right: 5%;">%</span>
                          }
                        </td>
                      }@else {
                        <td [ngClass]="{'total':elem.codigo==='suma','redText':ban<0}" class="w3-elemento-tableIndicador borderSup alinRight borderInf widthMin">
                          @if (elem.codigo!=='texto') {
                            <span style="margin-right: 5%;">
                              {{formNum(ban, false)}}
                            </span>
                          }@else {
                            <div [ngClass]="{'redTexts':ban==='VRL','yellowTexts':ban==='Cubierto con AL','greenTexts':ban==='GAP positivo'}"
                              style="margin-right: 5%; font-weight: 500;">
                              {{ban}}
                            </div>
                          }
                        </td>
                      }
                    }
                    <td class="w3-elemento-tableIndicador alinRight widthMinTot" [ngClass]="{'total borderInf borderIzq borderSup':t<5}">
                      <span style="margin-right: 5%;">{{formNum(elem.total, false)}}</span>
                    </td>
                    <td class="w3-elemento-tableIndicador alinRight" [ngClass]="{'total borderInf borderSup':t<5}">
                      @if (elem.eval && elem.total!==dataOrdenadoComp[t][i].total) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen" [customTooltip]="tooltipTemplate">info_outline</mat-icon>
                        </span>
                      }@else if (elem.eval && elem.total===dataOrdenadoComp[t][i].total) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen">done</mat-icon>
                        </span>
                      }
                      <ng-template #tooltipTemplate>
                        <div class="w3-row"> 
                          <div class="w3-row"> <strong> Los valores difieren </strong> </div>
                          <div class="w3-row alinCenter">
                            BDD: {{formNum(elem.total, false)}} <br> AT: {{formNum(dataOrdenadoComp[t][i].total, false)}}
                          </div>
                        </div>
                      </ng-template>
                    </td>
                    <td class="w3-elemento-tableIndicador alinRight" [ngClass]="{'total borderInf borderDer borderSup':t<5}">
                      @if (elem.edit) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen" style="cursor: pointer;" (click)="mostrarPorcentajes(elem.pos)">edit</mat-icon>
                        </span>
                      }
                      @if (idPlantilla !== 7 && elem.manual) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen" style="cursor: pointer;" (click)="mostrarEditables(elem, elem.valBan)">edit</mat-icon>
                        </span>
                      }
                    </td>
                  </tr>
                }@else if (elem.codigo!=='suma' && tablasExpand[t]) {
                  <tr class="w3-table-trtd">
                    <td [ngClass]="{'total':elem.codigo==='suma'||elem.codigo==='sumaPar'}" class="w3-elemento-tableIndicador borderInf borderIzq borderDer marginsH"
                    style="min-width: max-content !important; white-space: nowrap;">
                      {{elem.name}}
                    </td>
                    @for (ban of elem.bandas; track ban; let j = $index) {
                      @if (ban!==null) {
                        <td [ngClass]="{'total':elem.codigo==='suma'||elem.codigo==='sumaPar','redText':ban<0}" style="line-height: 1.2;"
                        class="w3-elemento-tableIndicador alinRight borderSup borderInf widthMin borderIzq borderDer marginIzq">
                          @if (elem.codigo!=='texto') {
                            <span style="margin-right: 5%;">
                              {{formNum(ban, false)}}
                            </span>
                          }@else {
                            <div [ngClass]="{'redTexts':ban==='VRL','yellowTexts':ban==='Cubierto con AL','greenTexts':ban==='GAP positivo'}"
                              style="font-weight: 500;">
                              {{ban}}
                            </div>
                          }
                          @if (elem.codigo==='porcentaje') {
                            <span style="margin-right: 5%;">
                              %
                            </span>
                          }
                        </td>
                      }@else {
                        <td [ngClass]="{'total':elem.codigo==='suma'||elem.codigo==='sumaPar','redText':ban<0}" class="w3-elemento-tableIndicador alinRight borderSup borderInf widthMin">
                          @if (elem.codigo!=='texto') {
                            <span style="margin-right: 5%;">
                              {{formNum(ban, false)}}
                            </span>
                          }@else {
                            <div [ngClass]="{'redTexts':ban==='VRL','yellowTexts':ban==='Cubierto con AL','greenTexts':ban==='GAP positivo'}"
                              style="font-weight: 500;">
                              {{ban}}
                            </div>
                          }
                        </td>
                      }
                    }
                    <td class="w3-elemento-tableIndicador alinRight widthMinTot borderIzq" [ngClass]="{'total borderInf borderSup':t<5}">
                      <span style="margin-right: 5%;">{{formNum(elem.total, false)}}</span>
                    </td>
                    <td class="w3-elemento-tableIndicador alinRight" [ngClass]="{'total borderInf borderSup':t<5}">
                      @if (elem.eval && elem.total!==dataOrdenadoComp[t][i].total) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen" [customTooltip]="tooltipTemplate">info_outline</mat-icon>
                        </span>
                      }
                      @if (elem.eval && elem.total===dataOrdenadoComp[t][i].total) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen">done</mat-icon>
                        </span>
                      }
                      <ng-template #tooltipTemplate>
                        <div class="w3-row"> 
                          <div class="w3-row"> <strong> Los valores difieren </strong> </div>
                          <div class="w3-row alinCenter">
                            BDD: {{formNum(elem.total, false)}} <br> AT: {{formNum(dataOrdenadoComp[t][i].total, false)}}
                          </div>
                        </div>
                      </ng-template>
                    </td>
                    <td class="w3-elemento-tableIndicador alinRight" [ngClass]="{'total borderInf borderSup borderDer':t<5}">
                      @if (elem.edit) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen" style="cursor: pointer;" (click)="mostrarPorcentajes(elem)">edit</mat-icon>
                        </span>
                      }
                      @if (idPlantilla !== 7 && elem.manual) {
                        <span style="margin-right: 5%;">
                          <mat-icon class="iconoMen" style="cursor: pointer;" (click)="mostrarEditables(elem, elem.valBan)">edit</mat-icon>
                        </span>
                      }
                    </td>
                  </tr>
                }
              }
              @if (t === 8) { <!--ANALISIS DE ESTRES-->
                <tr class="w3-table-title">
                  <th [attr.colspan]="(bandas.length ?? 0) + 4" class="stikyColum3 w3-elemento-titulo-table w3-center">
                    <span>{{ 'liquidez.gap.titSec11' | translate }}</span>
                  </th>
                </tr>
                <tr class="w3-table-trtd">
                  <td colspan="2" class="resaltarElemento alinRight">Máximo ingreso de cartera:</td>
                  <td colspan="1">
                    <mat-form-field appearance="outline" style="max-width: 5vw !important; margin-left: 1vw; margin-top: 1vh;">
                      <input id="maximoIng" type="number" matInput value="{{maximoIng}}" max="100" (change)="actualizarTablas2()">
                    </mat-form-field>
                  </td>
                  @if (idPlantilla === 7) {
                    <td colspan="2" class="resaltarElemento alinRight">Porcentaje máx. Ctas x Cob:</td>
                    <td colspan="1" class="">
                      <mat-form-field appearance="outline" style="max-width: 5vw !important; margin-left: 1vw; margin-top: 1vh;">
                        <input id="porMax" type="number" matInput value="{{porMax}}" max="100" (change)="actualizarTablas2()">
                      </mat-form-field>
                    </td>
                    <td colspan="2" class="resaltarElemento alinRight">Captaciones vista acotadas:</td>
                    <td colspan="2" class="resaltarElemento">
                        <input type="checkbox" style="cursor: pointer; margin-left: 0.7vh; float: left;" (change)="actualizarTablas2('camb')">
                    </td>
                    <td colspan="2" class="resaltarElemento"></td>
                  }
                  
                </tr>
              }
            }
          </tbody>
        </table>
      }@else {
        <table class="w3-table">
          <tr>
            @for (m of skeletonColums; track $index) {
              <td>
                <ngx-skeleton-loader count="1" [theme]="{ 
                  'border-radius': '10px',
                  height: '3.5vh',
                  width: '15vw',
                }" />
                @for (n of skeleton; track $index) {
                  <ngx-skeleton-loader count="1" [theme]="{ 
                    'border-radius': '10px',
                    height: '3vh',
                    width: '15vw',
                  }" />
                }
              </td>
            }
          </tr>
        </table>
      }
    </div>
  </div>
</app-esqueleto-tableros>


<app-modal [isOpen]="modal" (close)="closeModal()">
  <div modal-header>
    {{tituloEdit}} &bull; {{subTitles}}
  </div>

  <div modal-body>
    <table class="w3-table">
      <tbody>
        @for (ban of bandas; track ban; let i = $index) {
          <tr class="allBordes">
            <th class="stikyColum textoOverFlow w3-elemento-titulo-table allBordes"
                style="width: 50%; padding: 0 10px">
              <span>
                {{ (idPlantilla === 7 ? 'liquidez.gap.' + ban : ban) | translate }}
              </span>
            </th>
            <td class="alinCenter"
                style="padding: 0px">
              @if (bandasValues[i] !== null && bandasValues[i] !== undefined) {
                <div style="padding: 0px">
                  <input
                    id="{{ 'valor' + i }}"
                    matInput
                    [disabled]="edit"
                    class="inputTable"
                    [(ngModel)]="bandasValues[i]"
                    (ngModelChange)="actualizarBanda(i, $event)"
                    (focus)="seleccionarCero($event)"
                    currencyMask
                    [options]="{
                      thousands: ',',
                      decimal: '.',
                      precision: 0,
                      nullable: false,
                      aling: 'center',
                      prefix: ''
                    }">
                </div>
              }
            </td>
          </tr>
        }
        <tr class="allBordes">
          <th class="stikyColum textoOverFlow w3-elemento-titulo-table allBordes"
              style="width: 50%; padding: 0 10px ">
            <span>
              {{ 'liquidez.gap.tituloTabla2' | translate }}
            </span>
          </th>
          <td class="alinCenter"
              style="width: 50%; padding: 0;">
            <input
              matInput
              [disabled]="true"
              class="inputTable"
              [value]="totalPorcen"
              currencyMask
              [options]="{
                thousands: ',',
                decimal: '.',
                precision: 0,
                aling: 'center',
                prefix: ''
              }">
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  @if (edit) {
    <app-button modal-footer
      [icon]="'edit'"
      [color]="'#fff'"
      (click)="edit = false"
    />
  } @else {
    <div modal-footer class="contenedorFooter" style="width: 100%;">
      <div class="leyenda" style="font-size: 0.6rem;">
        <mat-icon class="iconoL">
          info_outline
        </mat-icon>
        Haz click en la 
        <mat-icon class="iconoL">
          done
        </mat-icon>
        para guardarlos datos
      </div>

      <mat-icon class="iconoL buttonPal"
        style="color: #ff6b00; cursor: pointer;"
        (click)="idEdit.edit ? guardarPorcentajes(): guardarVariables()">
        done
      </mat-icon>
    </div>
  }
</app-modal>

<mat-menu #menutabla1="matMenu">
  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="formN">
    <span>{{moneda}}/Miles</span>
  </button>
  <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportExcel()">
    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
    <span>{{'menu.Exportar'|translate}}</span>
  </button>
</mat-menu>
<mat-menu #formN="matMenu">
  <button [ngClass]="{'w3-disabled':formato===''}" class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="formato=''">
    <span>{{moneda}}</span>
  </button>
  <button [ngClass]="{'w3-disabled':formato==='miles'}" class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="formato='miles'">
    <span>Miles</span>
  </button>
</mat-menu>